// extracted by mini-css-extract-plugin
export default {"no_results":"common-typeahead-results-NoResults__no_results--2UlUM","small_font":"common-typeahead-results-NoResults__small_font--_Pyaa"};